import { type ZakelijkeRelatie, Relatietype } from './types';

export const emptyRelation: ZakelijkeRelatie = {
  typeName: Relatietype.Z,
  automatischeIncassoAkkoord: false,
  contactpersoon: undefined,
  email: '',
  rekening: undefined,
  rechtsvorm: undefined,
  incasso: undefined,
  telefoonnummer: '',
  vestigingsnummer: 1,
  adres: {
    huisnummer: undefined,
    huisnummertoevoeging: '',
    plaats: '',
    postcode: '',
    straat: '',
  },
  kvknummer: undefined,
  bedrijfsnaam: undefined,
  relatienummer: 0,
  relatieId: '',
  sbicode: '',
};
